import { Room, StatusItem } from './models';

export const NOT_SUPPORTED_IMAGE_EXTENSION = (fileName: string) =>
  'ファイル種類を対応できません。利用可能なファイルは jpg, jpeg, gif, png になります。ファイル名：' + fileName;
export const DROPDOWN_AREA_PROMPT = 'ここをクリックまたは画像ファイル（jpg, jpeg, gif, png）をドロップしてください。';
export const UPLOAD_IMAGE_ERROR =
  '申し訳ございません。データサーバーと接続できないため、画像ファイルをアップロードできませんでした。';
export const LOAD_IMAGE_ERROR = '申し訳ございません。画像ファイルを処理が不可能ためアップロードできませんでした。';
export const CHANGE_ROOM_SETTINGS_ERROR =
  '申し訳ございません。現在ルームで他のオンラインユーザーがいますのでルーム設定の変更できません。';
export const JITSI_VIDEO_NOT_AVAILABLE =
  'ビデオデバイスを取得できません。考えられる原因：他のアプリでカメラが使われているかカメラが接続されていません。バーチャル環境ではビデオ機能がサポートされていません。';
export const JITSI_AUDIO_NOT_AVAILABLE =
  'オーディオデバイスを取得できません。考えられる原因：他のアプリでマイクが使われているかマイクが接続されていません。';
export const DEVICE_NO_SPEAKER_AVAILABLE = 'スピーカーが接続されていません。';
export const DEVICE_CANNOT_ACQUIRE_NO_JS_FUNCTIONS =
  'メディアデバイスを取得できません。ブラウザ変更をお勧めいたします。';
export const DEVICE_NO_HTTPS = 'メディアデバイスのアクセスのためhttpsが必須です。';
export const DEVICE_ERROR_TITLE = 'メディアデバイスエラー';
export const CONNECTION_LOST_MESSAGE =
  '申し訳ございませんがサーバーと接続できません。もう一回ルームを入ってみてください。';

export const UPLOAD_AVATAR_TIMEOUT = 15 * 1000;

export const MAX_AVATAR_WIDTH_AND_HEIGHT = 110;
export const MAX_UPLOADED_IMAGE_WIDTH = 3000;
export const MAX_UPLOADED_IMAGE_HEIGHT = 1600; // ご注文： if you change this value, change $MaxImageHeight in css as well
export const MAX_SHARE_SCREEN_VIDEO_HEIGHT = 1600; // ご注文: if you change this value, change $MaxShareScreenVideoHeight in css as well

export const ROOM_FULL_SPACE_WIDTH = 3200; // analogical variable in data server code (constants.ts)
export const ROOM_FULL_SPACE_HEIGHT = 1800; // analogical variable in data server code (constants.ts)

export const MAX_RECENT_ROOMS_DISPLAYED = 5;

export const SPACE_ROOM_SEPARATOR = '+';

export const ELEMENT_ID_REMOTE_VIDEO_ELEMENT = (participantId: string) => 'remoteVideo' + participantId;
export const ELEMENT_ID_REMOTE_AUDIO_ELEMENT = (participantId: string) => 'remoteAudio' + participantId;
export const ELEMENT_ID_LOCAL_VIDEO_CONTAINER = 'localVideoContainer';
export const ELEMENT_ID_WHITEBOARD = 'whiteboardId';
export const ELEMENT_ID_LOCAL_MESSAGE = 'localMessagePopup';
export const ELEMENT_ID_TOGGLE_USERS_LIST_BUTTON = 'toggleUsersListButtonId';
export const ELEMENT_ID_DRAGGABLE_VIEWPORT = 'draggableViewportId';
export const ELEMENT_ID_MESSAGE: {
  button: string;
  svg: string;
  container: string;
  textarea: string;
  sendButton: string;
} = {
  button: 'messageButtonId',
  svg: 'messageSvgId',
  container: 'messageContainerId',
  textarea: 'messageTextareaId',
  sendButton: 'messageSendButtonId',
};

export const NO_SOUND_THRESHOLD_DISTANCE = 900;
export const NOT_DISTANCE_SENSITIVE_SOUND_THRESHOLD_DISTANCE = 500;

export const SCALE_ON_WHEEL_SPEED = 0.05; // can be a value between [0.01, 0.99]
export const MAX_SCALE_ON_PINCH = 700; // maximum distance between two fingers when pinch zooming (touch screen)

export const CHECK_IF_CONNECTED_WITH_DATA_SERVER_INTERVAL = 1500;

export const YOUTUBE_PREFIX_URL = 'https://www.youtube-nocookie.com/embed/';

export const statusList: StatusItem[] = [
  { id: 'Available', type: 'available', name: '連絡可能', selectable: true },
  { id: 'Busy', type: 'busy', name: '取込中', selectable: true },
  { id: 'BusyIdle', type: 'busy', name: '取込中', selectable: false },
  { id: 'DoNotDisturb', type: 'busy', name: '応答不可', selectable: false },
  { id: 'AvailableIdle', type: 'away', name: '退席中', selectable: false },
  { id: 'Away', type: 'away', name: '退席中', selectable: true },
  { id: 'BeRightBack', type: 'away', name: '一時退席中', selectable: false },
  { id: 'Offline', type: 'offline', name: 'オフライン', selectable: false },
  {
    id: 'PresenceUnknown',
    type: 'offline',
    name: 'オフライン',
    selectable: false,
  },
];

export const DefaultDatePickerLangSettings: any = {
  // the locale of formatting and parsing function
  formatLocale: {
    // MMMM
    //months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    // MMM
    // monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    // dddd
    // weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdays: ['日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'],
    // ddd
    // weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
    // dd
    // weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    weekdaysMin: ['日', '月', '火', '水', '木', '金', '土'],
    // // first day of week
    // firstDayOfWeek: 0,
    // // first week contains January 1st.
    // firstWeekContainsDate: 1,
    // // format 'a', 'A'
    // meridiem: (h: number, _: number, isLowercase: boolean) => {
    //   const word = h < 12 ? 'AM' : 'PM';
    //   return isLowercase ? word.toLocaleLowerCase() : word;
    // },
    // // parse ampm
    // meridiemParse: /[ap]\.?m?\.?/i,
    // // parse ampm
    // isPM: (input: string) => {
    //   return `${input}`.toLowerCase().charAt(0) === 'p';
    // },
  },
  // // the calendar header, default formatLocale.weekdaysMin
  // days: [],
  // // the calendar months, default formatLocale.monthsShort
  // months: [],
  // the calendar title of year
  yearFormat: 'YYYY年',
  // the calendar title of month
  monthFormat: 'MMM',
  // the calendar title of month before year
  monthBeforeYear: false,
};

export const FULL_HD_CONSTRAINTS: MediaTrackConstraints = {
  width: { ideal: 1920, max: 1920 },
  height: { ideal: 1080, max: 1080 },
};
export const LOW_RESOLUTION_CONSTRAINTS: MediaTrackConstraints = {
  width: { ideal: 10, max: 10 },
  height: { ideal: 10, max: 10 },
};

export const SCREEN_SHARE_IDLE_TIMEOUT = 120 * 60 * 1000; // 120 minutes
export const DEFAULT_SCREEN_SHARE_SCOPE = 'room';
export const DEFAULT_ENABLE_SCREEN_SHARE_IDLING = true;
